import store from "@/store";
import { defineComponent, onMounted, ref } from "vue";
import { useLDFlag } from "launchdarkly-vue-client-sdk";
import { FeatureFlags } from "@/plugins/launchDarkly/featureFlags";

export default defineComponent({
  name: "TopMenu",
  props: {
    folder: {
      type: String,
      required: true,
    },
    highlightedIndex: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const menu = ref();

    const featureFlagChecks: Record<string, ReturnType<typeof useLDFlag>> = {
      [FeatureFlags.REPORT_SCHEDULES]: useLDFlag(FeatureFlags.REPORT_SCHEDULES, false),
      [FeatureFlags.DISTRIBUTION_SETTINGS_PLATFORM]: useLDFlag(FeatureFlags.DISTRIBUTION_SETTINGS_PLATFORM, false),
      [FeatureFlags.USER_ARCHIVE]: useLDFlag(FeatureFlags.USER_ARCHIVE, false),
    };

    onMounted(async () => {
      menu.value = (await import(`@/json/${props.folder}`)).default;
    });

    return {
      menu,
      props,
      store,
      featureFlagChecks,
    };
  },
});
